module.exports = __webpack_public_path__ + "static/media/dentalcavities.c139a7d7.png";